export function normalizeOtp(value: string, maxDigits = 4): string {
  const limit = Number.isInteger(maxDigits) && maxDigits >= 4 && maxDigits <= 10 ? maxDigits : 4;
  return value
    .replace(/[٠-٩]/g, (digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)))
    .replace(/[۰-۹]/g, (digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
    .replace(/\D/g, "")
    .slice(0, limit);
}
